import React, { useEffect, useState } from "react";
import "./Key_Benefits.css";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { useParams } from "react-router-dom";
import { IDS } from "../../../../utils/common";

const Key_Benefits = () => {
  const { id } = useParams();

  const [serviceName, setServiceName] = useState("");
  const [serviceImage, setServiceImage] = useState("");
  const [keybenefit, setKeyBenefit] = useState([]);

  const getKeyBenefit = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setServiceName(res?.data?.name || "");
      setServiceImage(res?.data?.image || "");
      setKeyBenefit(res?.data?.key_benefit_id || []);
    }
  };

  useEffect(() => {
    if (id) {
      getKeyBenefit();
    }
  }, [id]);

  const middle = Math.ceil(keybenefit.length / 2);
  const leftKey = keybenefit.slice(0, middle);
  const rightKey = keybenefit.slice(middle);

  return (
    <section className="Key_Benefits">
      <div className="container">
        <h5 className="Key_Benefits_header">Key Benefits of {serviceName}</h5>

        <div className="row justify-content-center align-items-center mt-5">
          {/* LEFT SIDE */}
          <div className="col-lg-3 col-md-6 col-sm-7 points_col">
            <div className="points_wrapper">
              {leftKey.map((item, index) => (
                <div className="point_box" key={item.value}>
                  <h5 className="choose_number">{index + 1}</h5>

                  <p className="choose_text">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CENTER IMAGE */}
          <div className="col-lg-5 col-md-7 col-sm-8">
            <div className="center_img_holder">
              <p className="img_text">{serviceName}</p>

              <div className="img_div">
                <img
                  src={IDS?.IMG_URL + serviceImage}
                  alt="feature-img"
                  className="center_img"
                />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-3 col-md-6 col-sm-7 points_col">
            <div className="points_wrapper">
              {rightKey.map((item, index) => (
                <div className="point_box" key={item.value}>
                  <h5 className="choose_number">{middle + index + 1}</h5>

                  <p className="choose_text">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Key_Benefits;
